<template>
  <tr class="leaderboard-table__row">
    <router-link v-if="tableItem.name" class="leaderboard-table__link" :to="{ name: 'team', params: { id: tableItem.id }}">
          <td class="leaderboard-table__cell leaderboard-table__item-details">

      <v-avatar
        size="31px"
        class="mr-2"
      >
        <img 
          v-if="tableItem.avatar"
          :src="tableItem.avatar"
          alt="Avatar"
        >
        <i
          v-else
          class="fas fa-user"
        />
      </v-avatar>
      <span>{{ tableItem.name || tableItem.first_name + ' ' + tableItem.last_name }}</span>
    </td>
    </router-link>  
    <router-link v-else class="leaderboard-table__link" :to="{ name: 'user', params: { id: tableItem.id }}">
      <td class="leaderboard-table__cell leaderboard-table__item-details">

      <v-avatar
        size="31px"
        class="mr-2"
      >
        <img 
          v-if="tableItem.avatar"
          :src="tableItem.avatar"
          alt="Avatar"
        >
        <i
          v-else
          class="fas fa-user"
        />
      </v-avatar>
      <span>{{ tableItem.name || tableItem.first_name + ' ' + tableItem.last_name }}</span>
    </td>
    </router-link>  
    <td class="leaderboard-table__cell leaderboard-table__total-zar">
      <!-- <LeaderBoardProgressbar
        v-bind:points="tableItem.zar || tableItem.nmg_miles"
        v-bind:divider="divider"
      /> -->
      <LeaderBoardProgressbar
        v-bind:points="tableItem.nmg_mile || tableItem.nmg_miles"
        v-bind:divider="divider"
      />
    </td>
  </tr>
</template>

<script>
  import LeaderBoardProgressbar from './LeaderBoardProgressbar';

  export default {
    name: "LeaderBoardTableRow",
    props: ['tableItem', 'divider'],
    components: {
      LeaderBoardProgressbar
    }
  }
</script>

<style scoped>
  .leaderboard-table__row {

  }

  .leaderboard-table__cell {
    padding: 15px 0;
  }

  .leaderboard-table__item-details {
    width: 170px;
    padding: 5px 0;
    font-size: 15px;
    font-weight: bold;
  }

  .leaderboard-table__total-zar {

  }
    .leaderboard-table__link {
    color: rgb(0, 0, 0);
    text-decoration: none;
  }
</style>
